import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'hypecast-master-admin-navigation-link',
  templateUrl: './navigation-link.component.html',
  styleUrls: ['./navigation-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLinkActive, RouterLink, MatIcon],
})
export class NavigationLinkComponent {
  readonly link = input.required<string>();

  readonly icon = input.required<string>();

  readonly displayName = input.required<string>();
}
